<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :readOnly="readOnly"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_CULTURE_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.adminContext.culture;
          // console.log("culture", this.editableEntry);
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(culture) {
      this.pageLoading = true;
      // console.log("culture", culture);
      this.$apollo
        .mutate({
          mutation: UPDATE_CULTURE_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(culture, this.editableEntry.validations)
          }
        })
        .then(response => {
          var errors = response.data.updateCulture.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_CULTURE_QUERY = gql `
  query ($id: ID!) {
    adminContext {
      culture(id: $id) {
        id
        name
        scientificName
        description
        forage
        unitId
        unit {
          id
          name
        }
        packagingIds
        packagingId
        packaging {
          id
          name
        }
        newVarieties{
          name
          commonName
          scientificName
        }
        validations
      }      
    } 
    globalContext {
      allUnits {
        id
        name
      }
      allPackagings {
        id
        name
      }
      allBusinessActivities{
        id
        name
      }
    }
  }
`;

const UPDATE_CULTURE_MUTATION = gql `
  mutation($input: CultureUpdateInputObject!) {
    updateCulture(input: $input) {
      culture {
        id
        name
        description  
        forage     
        scientificName
        unitId
        unit {
          id
          name
        }
        packagingId
        packaging {
          id
          name
        }
        packagings{
          id
          name
        }
        packagingIds
      }
      errors
    }
  }
`;

</script>

<style scoped></style>